__turbopack_context__.v({
  "dragging": "slider-module-scss-module__Xwp_TW__dragging",
  "modal": "slider-module-scss-module__Xwp_TW__modal",
  "rootCustom": "slider-module-scss-module__Xwp_TW__rootCustom",
  "slick-arrow": "slider-module-scss-module__Xwp_TW__slick-arrow",
  "slick-hidden": "slider-module-scss-module__Xwp_TW__slick-hidden",
  "slick-initialized": "slider-module-scss-module__Xwp_TW__slick-initialized",
  "slick-list": "slider-module-scss-module__Xwp_TW__slick-list",
  "slick-loading": "slider-module-scss-module__Xwp_TW__slick-loading",
  "slick-slide": "slider-module-scss-module__Xwp_TW__slick-slide",
  "slick-slider": "slider-module-scss-module__Xwp_TW__slick-slider",
  "slick-track": "slider-module-scss-module__Xwp_TW__slick-track",
  "slick-vertical": "slider-module-scss-module__Xwp_TW__slick-vertical",
  "sliderFallback": "slider-module-scss-module__Xwp_TW__sliderFallback",
});
